// ##############################
// // // ValidationForms view styles
// #############################

import {cardTitle} from "../material-dashboard-pro-react.jsx";
import customCheckboxRadioSwitch from "../material-dashboard-pro-react/customCheckboxRadioSwitch.jsx";

const reduxFieldStyles = {
    ...customCheckboxRadioSwitch,
    cardTitle: {
        ...cardTitle,
        color: "#FFFFFF"
    },
    cardIconTitle: {
        ...cardTitle,
        marginTop: "15px",
        marginBottom: "0px"
    },
    formCategory: {
        marginBottom: "0",
        color: "#999999",
        fontSize: "14px",
        padding: "10px 0 10px"
    },
    center: {
        textAlign: "center"
    },
    justifyContentCenter: {
        justifyContent: "center"
    },
    registerButton: {
        float: "right"
    },
    formGroup: {
        paddingTop: "12px"
    },
    inlineFormControl: {
        margin: '0'
    },
    inputLabel: {
        top: '10px',
        color: '#AAAAAA !important',
        fontSize: '14px',
        fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
        fontWeight: '400',
        lineHeight: '1.42857',
        zIndex: '1',
    }
};

export default reduxFieldStyles;



// WEBPACK FOOTER //
// ./src/assets/jss/reduxFields/ReduxField.js